<div class="content-container">
    <mat-card class="login-component">
        <mat-card-header class="login-header">
            <mat-card-title class="mat-card-title">
                <mat-icon class="material-symbols-outlined">
                    contact_mail
                </mat-icon>
                <app-search-marquee #searchMarquee [searchRequestTypeEnum]="searchRequestTypeEnum"
                                    [searchRequestTileComponentTypeName]="searchRequestTileComponentTypeName"
                                    [disabled]="isSearchMarqueeDisabled">
                </app-search-marquee>
            </mat-card-title>
            <mat-card-subtitle class="mat-card-subtitle">
                <!--Enter search criteria to locate contacts-->
            </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
            <form>
                <br />
                <!--<mat-tab-group *ngIf="searchResult.length > 0">
                    <mat-tab label="Results">
                        <br />-->
                        <table mat-table [dataSource]="searchResultDatasource" class="search-result mat-elevation-z8" matSort>
                            <ng-container matColumnDef="Avatar">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                                <td mat-cell *matCellDef="let contact" (click)="editItem(contact.ContactId)">
                                    <mat-icon class="material-symbols-outlined">
                                        <app-image srcPath="{{ contact.AvatarBlobPath == null ? appService.defaultImageUri : contact.AvatarBlobPath }}" isApiImage="{{ contact.AvatarBlobPath == null ? 'false' : 'true' }}" (click)="editItem(contact.ContactId)" class="margin-wide-right nudge-down-small" className="app-image-extra-small app-image-circle"></app-image>
                                    </mat-icon>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="Name">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
                                <td mat-cell *matCellDef="let contact" (click)="editItem(contact.ContactId)">
                                    {{ contact.Name }}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="Delete">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                                <td mat-cell *matCellDef="let contact">
                                    <button mat-button (click)="deleteItem(contact.ContactId, contact.Name)">
                                        <mat-icon class="material-symbols-outlined">
                                            delete_forever
                                        </mat-icon>
                                    </button>
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                        </table>
                    <!--</mat-tab>
                </mat-tab-group>-->
            </form>
        </mat-card-content>
        <mat-card-footer>
        </mat-card-footer>
    </mat-card>
</div>

